module.exports = __webpack_public_path__ + "img/T1C_xh_15.fd121ce1.png";